import { useState } from "react";
import { setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode"
import { MapInputsFromEditList } from "../Stylebuilder"
import { SiteData } from "../Data/SiteData";
import { AttributeTargetType } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";




export default function PageSpacingMenu({saveFunc,siteData}:{saveFunc:Function,siteData:SiteData}){

    
    
  const [page,setPage] = useState(siteData.siteStyling.pageWidth);



    const updateAtt = (  attribute: string, value: string, targetType: AttributeTargetType) =>{
          
       

        setNodeComponentAttributeValue(page,attribute,value);
        siteData.siteStyling.pageWidth = page;
        setPage(page);
        saveFunc();

        }


    return(
           <>
              <h2 className="panel-heading">Page Spacing</h2>
           
              <MapInputsFromEditList
              
                editList={["pageWidth","defaultPadding"]}
                layoutNode={
                 page
                }
                screenSize={ScreenSize.Desktop}
                updateFunc={updateAtt}
                saveFunc={ saveFunc}
                showScreenSize={false}
                siteData={siteData}
              />
             
            </>
)





}